module.exports = __webpack_public_path__ + "static/media/dream-sleep.6aeb4c9d.png";